import { Destination } from 'app/models/Destination';
import { Tour } from 'app/models/Tour';

export const mergeSearchDestinations = (
  catalogDestinations: Destination[],
  tours: Tour[],
): Destination[] => {
  const destinationIds = new Set(
    catalogDestinations.map(destination => destination.id),
  );
  const searchedDestinations = tours.flatMap(tour => {
    if (!tour.destination || destinationIds.has(tour.destination.id)) {
      return [];
    }

    destinationIds.add(tour.destination.id);
    return [tour.destination];
  });

  return [...catalogDestinations, ...searchedDestinations];
};
